<template>
  <div class="" id="Workflow">
    <card collapse :Name="'ListWorkFlow'">
      <template v-slot:header>
        <h3>لیست مسیرهای کاری ثبت شده</h3>
        <hr />
      </template>
      <template v-slot:content>
        <div class="row" id="ListWorkFlow" :key="Render">
          <div class="col-md-3" v-for="(item, key) in ListWorkflow" :key="key">
            <div class="card h-100">
              <div class="card-body">
                <i class="fal fa-bezier-curve ml-3"></i><span style="margin-top: auto">{{ item.name }}</span>
                <b-dropdown size="md" variant="link" class="d-inline float-left btn-more text-center" toggle-class="text-decoration-none " no-caret>
                  <template #button-content>
                    <h4><i class="fad fa-ellipsis-v"></i></h4>
                  </template>
                  <b-dropdown-item @click="Edit(item, false)" class="text-center" v-b-toggle="'ListWorkFlow'"> مشاهده </b-dropdown-item>
                  <b-dropdown-item @click="Edit(item, true)" class="text-center" v-b-toggle="'ListWorkFlow'"> ویرایش</b-dropdown-item>
                  <!-- <b-dropdown-item @click="Delete(item)" class="text-center">حذف </b-dropdown-item> -->
                </b-dropdown>
              </div>
            </div>
          </div>
          <div class="col-12" v-if="ListWorkflow.length == 0">
            <div class="bordered text-center">مسیر کاری یافت نشد</div>
          </div>
        </div>
      </template>
    </card>

    <card>
      <template v-slot:header>
        <div class="row">
          <div class="col-md-1 col-12 text-center p-0">
            <i
              class="fas fa-plus Pointer fa-2x mt-4 text-info"
              title="ایجاد مسیر کاری جدید"
              @click="
                DataAxiosFinal = []
                isEditMode = false
                isShowMode = false
                WorkFlowName = ''
                NewWorkFlow()
              "
            ></i>
          </div>
          <div class="col-md-5 col-12">
            <small> نام مسیر </small>
            <input type="text" class="form-control text-right required" v-model="WorkFlowName" v-if="!isShowMode" />
            <h3 class="text-warning" v-else>{{ WorkFlowName }}</h3>
            <span class="float-right" v-if="Id && Name && Id > 0" @click="GotoDepartemant"
              ><button class="btn btn-warning"><i class="fad fa-long-arrow-left mx-2"></i> بازگشت به لیست دپارتمان ها</button></span
            >
          </div>
          <div class="col-md-4 col-12" v-if="!isShowMode && DataAxiosFinal.length < 1">
            <small>نام دلخواه مرحله</small>
            <input type="text" class="form-control text-right required" v-model="DataAxios.LevelName" />
          </div>
          <div class="col-md-2 col-12" v-if="!isShowMode && DataAxiosFinal.length < 1">
            <button class="btn btn-success mt-4 w-100" dir="ltr" @click.prevent="SetWork()">اضافه کردن مرحله<i class="fas fa-plus ml-2"></i></button>
          </div>
        </div>
        <hr />
        <div class="row mt-3">
          <div class="col-12 text-danger text-center" v-if="isEditMode">دقت داشته باشید : بعد از ویرایش ، تنظیمات دسترسی و تنظیمات شرط و تنظیمات پیامک به حالت پیشفرض تغییر خواهند کرد و برای</div>
          <div class="col-md-12">
            <small>نمایش مسیــــر کاری {{ WorkFlowName }}</small>
          </div>
          <!-- اولین فلش  -->
          <div class="col-md-3" v-if="isEditMode && false">
            <i class="fad fa-arrow-alt-left text-warning fa-3x mt-5" @click="AddNewSteep(null, -1)" :class="!isShowMode ? 'hover-info Pointer' : ''" :title="!isShowMode ? 'اضافه کردن مرحله بعدی' : ''"></i>
          </div>
          <!-- پایان اولین فلش -->
          <div class="col-md-3" v-for="(item, key) in DataAxiosFinal" :key="key">
            <div class="row mt-2">
              <div class="col-10">
                <div class="card h-100">
                  <div class="card-header text-logo">
                    <!-- <span class="p-2 Number">{{ key + 1 }}</span>  &nbsp; &nbsp; -->
                    {{ item.LevelName }}
                    <span class="float-left Pointer" v-if="!isShowMode" title="حذف کلی مرحله" @click="DeleteSteep(item, key)"><i class="fad fa-trash hover-danger"></i></span>
                    <b-dropdown size="md" variant="link" class="d-inline float-left btn-more text-center" toggle-class="text-decoration-none " no-caret v-if="isShowMode">
                      <template #button-content>
                        <h4><i class="fad fa-ellipsis-v"></i></h4>
                      </template>
                      <b-dropdown-item class="text-center" @click="OpenAccessWorkflow(item)">تنظیمات دسترسی</b-dropdown-item>
                      <b-dropdown-item class="text-center" @click="OpenSettingSms(item)">تنظیمات پیامک</b-dropdown-item>
                      <b-dropdown-item class="text-center" @click="OpenCondition(item)">تنظیمات شرط</b-dropdown-item>
                    </b-dropdown>
                  </div>
                  <div class="card-body">
                    <div class="row" v-if="!isShowMode">
                      <div class="col-10" :key="Render">
                        <div class="">
                          <SearchableCombo :edit="false" :grp="322" :code="null" @ResultCombo="getuserId" :rownumintable="3" :action="'TblCrmCombo/GetComboById'" :method="'POST'" :idinput="'UserRoleId'" :keyItem="'UserRoleId' + key" :disabled="false"> </SearchableCombo>
                        </div>
                      </div>
                      <div class="col-2 pr-0">
                        <i class="fas fa-plus text-logo fa-2x Pointer" @click="SetUser(item)"></i>
                      </div>
                    </div>
                    <div class="row mt-4">
                      <div class="col-12 mt-3 border-box" v-for="(user, keyuser) in item.tblUserRols" :key="keyuser">
                        <i class="fad fa-trash hover-danger d-none ml-3 Pointer" @click="DeleteLvl(user, item)" v-if="!isShowMode"></i>
                        <span class="User">{{ user.tblUserRoleName }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-2 pr-0">
                <i class="fad fa-arrow-alt-left text-warning fa-3x mt-5" @click="AddNewSteep(item, key)" :class="!isShowMode ? 'hover-info Pointer' : ''" :title="!isShowMode ? 'اضافه کردن مرحله بعدی' : ''"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-3">
            <button v-if="DataAxiosFinal.length > 0 && !isEditMode && !isShowMode" class="btn btn-success mt-4 w-100" dir="ltr" @click.prevent="SaveWork()">ثبت مسیر کاری <i class="fas fa-plus ml-2"></i></button>
            <button v-if="DataAxiosFinal.length > 0 && isEditMode" class="btn btn-warning mt-4 w-100" dir="ltr" @click.prevent="EditWork()">اصلاح مسیر کاری <i class="fas fa-plus ml-2"></i></button>
          </div>
        </div>
      </template>
    </card>

    <modal v-if="$store.state.Modal" :InheritanceTheme="true" :IsFooter="false" :Size="ModalSize">
      <template v-slot:body>
        <div>
          <condition-workflow v-if="ModalCondition" :Data="Props" :Department="tblDepartmentId" @Close="CloseModal"></condition-workflow>
          <access-work-flow v-if="ModalAccess" :Data="Props" :Department="tblDepartmentId"></access-work-flow>
          <setting-sms v-if="ModalSettingSms" :Data="Props" :Department="tblDepartmentId"></setting-sms>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import SearchableCombo from '@/components/Combo/SearchableCombo.vue'
import Modal from '@/pages/Modal/Modal.vue'
import ConditionWorkflow from './ConditionWorkflow.vue'
import AccessWorkFlow from './AccessWorkFlow.vue'
import SettingSms from './SettingSms.vue'

export default {
  data() {
    return {
      WorkFlowName: '',
      WorkFlowId: 0,
      isEditMode: false,
      isShowMode: false,

      Render: 0,
      ListWorkflow: [],
      DataAxios: { tblWorkFlowId: 0, tartib: 0, LevelName: '', tblUserRols: [] },
      Level: 1,
      DataAxiosFinal: [],
      userRoleId: null,
      userRoleName: '',
      ModalCondition: false,
      ModalAccess: false,
      ModalSettingSms: false,
      Props: null,
      tblDepartmentId: null,
      ModalSize: 'Md',
    }
  },
  components: { Card, SearchableCombo, Modal, ConditionWorkflow, AccessWorkFlow, SettingSms },
  methods: {
    getuserId(value) {
      this.userRoleId = value.id
      this.userRoleName = value.name
    },
    SetWork() {
      // checkup required // Yadet Nare
      if (this.$ValidForm('Workflow')) {
        this.DataAxiosFinal.push(JSON.parse(JSON.stringify(this.DataAxios)))
        this.DataAxios.LevelName = ''
        this.DataAxios.users = []
      }
    },
    SetUser(item) {
      if (this.userRoleId != null) {
        let Find = item.tblUserRols.find((z) => z.tblUserRoleId == this.userRoleId)
        if (Find) {
          this.$toasted.error(' کاربر ' + this.userRoleName + ' قبلا به این مرحله اضافه شده لطفا کاربر دیگری را انتخاب نمایید', { duration: 3000 })
        } else {
          item.tblUserRols.push({ tblUserRoleId: this.userRoleId, tblUserRoleName: this.userRoleName, SendSms: false })
          this.Render++
          this.userRoleId = null
          this.userRoleName = null
        }
      } else {
        this.$toasted.error('کاربری انتخاب نشده ، ابتدا کاربر را انتخاب و سپس دکمه + را کلیک کنید', { duration: 3000 })
      }
    },
    DeleteLvl(item, Step) {
      let CopyStep = JSON.parse(JSON.stringify(Step))
      CopyStep.tblUserRols = Step.tblUserRols.filter((x) => x.tblUserRoleId == item.tblUserRoleId)
      this.$SweetQustion('عملیات حذف', 'از حذف نقش انتخابی اطمینان دارید ؟', 'warning', 'حذف', ' انصراف ', CopyStep, this.Delete, this.Cancel)
    },
    Delete(item) {
      this.DataAxiosFinal.forEach((e) => {
        e.tblUserRols.forEach((el) => {
          if (el.tblUserRoleId == item.tblUserRols[0].tblUserRoleId) {
            const index = e.tblUserRols.indexOf(el)
            if (index > -1) {
              e.tblUserRols.splice(index, 1)
            }
          }
        })
      })
      // this.SaveWork()
      this.$toasted.success('حذف آیتم با موفقیت انجام گردید', { duration: 2000 })
    },
    Cancel() {},
    SaveWork() {
      var obj = {
        WorkFlowName: this.WorkFlowName,
        tblWorkflowDetails: this.DataAxiosFinal,
        tblWorkFlowId: 0,
      }
      let DataAxios_SetData = {
        ArryfildValue: {},
        Method: 'post',
        Action: 'Workflow/SetWorkflow',
        Token: this.$session.get('Token'),
      }

      DataAxios_SetData.ArryfildValue = obj
      this.$PostData(DataAxios_SetData)
        .then((data) => {
          if (data.status == 'Ok') {
            this.$toasted.success('مسیر کاری با موفقیت ثبت گردید', { duration: 5000 })
            this.Render++
            this.DataAxiosFinal = []
            this.GetListWorkflow()
            // this.DataAxios = { FormAutomation: null, FormAutomationName: '', LevelName: '', users: [] }
          }
        })
        .finally(() => {})
    },
    EditWork() {
      for (let index = 0; index < this.DataAxiosFinal.length; index++) {
        const element = this.DataAxiosFinal[index]
        element.tartib = index + 1
      }
      console.log('😎 ~ EditWork ~ obj.this.DataAxiosFinal:', this.DataAxiosFinal)
      var obj = {
        WorkFlowName: this.WorkFlowName,
        tblWorkflowDetails: this.DataAxiosFinal,
        tblWorkFlowId: this.WorkFlowId,
      }
      let DataAxios_SetData = {
        ArryfildValue: {},
        Method: 'post',
        Action: 'Workflow/SetWorkflow',
        Token: this.$session.get('Token'),
      }

      DataAxios_SetData.ArryfildValue = obj
      this.$PostData(DataAxios_SetData)
        .then((data) => {
          if (data.status == 'Ok') {
            this.$toasted.success('مسیر کاری با موفقیت ثبت گردید', { duration: 5000 })
            this.Render++
            this.DataAxiosFinal = []
            this.GetListWorkflow()
            // this.DataAxios = { FormAutomation: null, FormAutomationName: '', LevelName: '', users: [] }
          }
        })
        .finally(() => {})
    },
    GetListWorkflow() {
      this.DataAxiosFinal = []
      var formData = new FormData()
      // formData.append('FormAutomationId', this.DataAxios.FormAutomation)
      var DataAxios = { Method: 'POST', Action: 'Workflow/GetListWorkflow', ArryfildValue: null }
      DataAxios.ArryfildValue = formData
      this.$PostFormData(DataAxios).then((res) => {
        if (res.status == 'Ok') {
          if (res.data.length > 0) {
            console.log('😎 ~ this.$PostFormData ~ res.data:', res.data)
            this.ShowMode = true
            this.ListWorkflow = res.data
          }
        } else {
          this.DataAxiosFinal = []
        }
      })
    },
    groupBy(array, key) {
      return array.reduce(function (result, obj) {
        var value = obj[key]
        if (!result[value]) {
          result[value] = []
        }
        result[value].push(obj)
        return result
      }, {})
    },
    OpenCondition(Step) {
      this.ModalSize = 'Md'
      this.ModalCondition = true
      this.ModalAccess = false
      this.ModalSettingSms = false
      this.$store.state.Modal = true
      this.Props = Step
    },
    OpenAccessWorkflow(Step) {
      this.ModalSize = 'Sm'
      this.ModalAccess = true
      this.ModalCondition = false
      this.ModalSettingSms = false
      this.$store.state.Modal = true
      this.Props = Step
    },
    OpenSettingSms(Step) {
      console.log('😎 ~ OpenSettingSms ~ Step:', Step)
      this.ModalSize = 'Sm'
      this.ModalAccess = false
      this.ModalCondition = false
      this.ModalSettingSms = true
      this.$store.state.Modal = true
      this.Props = Step
    },
    CloseModal() {
      this.$store.state.Modal = false
      this.ModalCondition = false
      this.ModalAccess = false
      this.ModalSettingSms = false
    },
    SetWorkFlow() {
      this.StateSaveWorkFlowName = 1
    },
    Edit(row, isEditMode) {
      this.isEditMode = false
      this.isShowMode = false
      this.WorkFlowId = row.id
      isEditMode == true ? (this.isEditMode = true) : (this.isShowMode = true)
      this.DataAxiosFinal = []
      this.WorkFlowName = row.name
      var formData = new FormData()
      formData.append('tblWorkFlowId', row.id)
      var DataAxios = { Method: 'POST', Action: 'Workflow/FindWorkflow', ArryfildValue: null }
      DataAxios.ArryfildValue = formData
      this.$PostFormData(DataAxios).then((res) => {
        console.log('😎 ~ this.$PostFormData ~ res:', res)
        if (res.status == 'Ok') {
          for (let index = 0; index < res.data.length; index++) {
            const element = res.data[index]
            var list = res.data.filter((x) => x.tartib == index + 1)
            // console.log("😎 ~ this.$PostFormData ~ list:", list)
            if (list.length > 0) {
              let Sample = { tblWorkFlowId: list[0].tblWorkFlowId, tartib: list[0].tartib, LevelName: list[0].levelName, tblUserRols: [] }
              list.forEach((el) => {
                Sample.tblUserRols.push({ Id: el.id, tblUserRoleId: el.tblComboGrpId322UserRole, tblUserRoleName: el.roleName, SendSms: el.sendSms })
              })
              this.DataAxiosFinal.push(Sample)
            }
          }
          console.log(this.DataAxiosFinal)
        } else {
        }
      })
    },
    FindWorkFlow(tblWorkFlowId) {
      this.isEditMode = false
      this.isShowMode = true
      this.DataAxiosFinal = []
      this.WorkFlowName = this.Name
      var formData = new FormData()
      formData.append('tblWorkFlowId', tblWorkFlowId)
      var DataAxios = { Method: 'POST', Action: 'Workflow/FindWorkflow', ArryfildValue: null }
      DataAxios.ArryfildValue = formData
      this.$PostFormData(DataAxios).then((res) => {
        if (res.status == 'Ok') {
          for (let index = 0; index < res.data.length; index++) {
            const element = res.data[index]
            var list = res.data.filter((x) => x.tartib == index + 1)
            if (list.length > 0) {
              let Sample = { tblWorkFlowId: list[0].tblWorkFlowId, tartib: list[0].tartib, LevelName: list[0].levelName, tblUserRols: [] }
              list.forEach((el) => {
                Sample.tblUserRols.push({ tblUserRoleId: el.tblComboGrpId322UserRole, tblUserRoleName: el.roleName, SendSms: el.sendSms })
              })
              this.DataAxiosFinal.push(Sample)
            }
          }
        } else {
        }
      })
    },
    NewWorkFlow() {
      this.$toasted.success('مسیر کاری برای ثبت جدید آماده است', { duration: 1500 })
    },
    GotoDepartemant() {
      this.$router.push({ name: 'AutomationDepartmen', params: { List: this.List, tbldepartemnet: this.tbldepartemnet } })
    },
    DeleteSteep(steep, index) {
      let Node = { item: steep, index: index }
      this.$SweetQustion('عملیات حذف', 'از حذف مرحله ' + steep.LevelName + ' اطمینان دارید ؟', 'question', 'حذف', ' انصراف ', Node, this.AcceptDeleteSteep, this.Cancel)
    },
    AcceptDeleteSteep(Node) {
      const index = this.DataAxiosFinal.indexOf(Node.item)
      if (index != -1) {
        this.DataAxiosFinal.splice(index, 1)
        this.$toasted.success('حذف مرحله با موفقیت انجام گردید', { duration: 1500 })
        var ind = Node.index + 1
        for (let i = ind + 1; i < this.DataAxiosFinal.length; i++) {
          const element = this.DataAxiosFinal[i]
          element.tartib = element.tartib + 1
        }
      } else {
        this.$toasted.error('خطا در حذف مرحله (مرحله یافت نشد)', { duration: 1500 })
      }
    },
    AddNewSteep(item, index) {
      let Node = { item: item, index: index }
      this.$SweetInput('افزودن مرحله جدید', 'نام مرحله جدید را وارد نمایید', 'info', 'اضافه کردن', ' انصراف ', Node, this.InsNewSteep, this.Cancel)
    },
    InsNewSteep(Node) {
      if (Node.inputValue != null) {
        this.DataAxios.LevelName = Node.inputValue
        this.DataAxios.tartib = Node.index + 2

        var index = Node.index + 1 // ایندکس مورد نظر برای اضافه کردن عنصر
        var valueToAdd = JSON.parse(JSON.stringify(this.DataAxios)) // مقداری که می‌خواهید به آرایه اضافه کنید
        this.DataAxiosFinal.splice(index, 0, valueToAdd)
        for (let i = index + 1; i < this.DataAxiosFinal.length; i++) {
          const element = this.DataAxiosFinal[i]
          element.tartib = element.tartib + 1
        }

        this.DataAxios.LevelName = ''
        this.DataAxios.tartib = 0
        this.DataAxios.users = []
      }
    },
  },
  props: ['Id', 'Name', 'List', 'tbldepartemnet'],
  created() {
    if (this.Id) {
      this.FindWorkFlow(this.Id)
    }
    this.GetListWorkflow()
  },
}
</script>
<style scoped>
.card {
  background: var(--sidebar-action-bg) !important;
}
#ListWorkFlow .card {
  border: 1px solid #5cb0ff !important;
}
#ListWorkFlow .fa-ellipsis-v {
  color: #5cb0ff;
}
.arrow {
  width: 120px;
}

.line {
  margin-top: 14px;
  width: 90px;
  background: var(--sidebar-color-item);
  height: 10px;
  float: right;
}

.point {
  width: 0;
  height: 0;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;
  border-right: 30px solid var(--sidebar-color-item);
  float: right;
}

.arrowltr {
  width: 120px;
}

.lineltr {
  margin-top: 14px;
  width: 90px;
  background: var(--sidebar-color-item);
  height: 10px;
  float: left;
}

.pointltr {
  width: 0;
  height: 0;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;
  border-left: 30px solid var(--sidebar-color-item);
  float: left;
}
.trash {
  display: none !important;
}
.border-box:hover .fa-trash {
  display: inline !important;
}
.border-box:hover .custom-control {
  display: inline !important;
}
.WF_Style {
  background: #5cb0ff;
  vertical-align: middle !important;
  height: 30px;
  border-radius: 5px;
}
</style>
